import React, { useEffect } from 'react';
import { useState } from 'react'
import Footer from "../../MyComponents/Footer";
import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
 import heroContent from './HeroContent';
 import leftimg from "../../assets/designleftimg.png";
import rightimg from "../../assets/designrightimg.png";
import adobe from "../../assets/adobeimg.png"
import corel from "../../assets/corelimg.png"
import photoshop from "../../assets/photoshopimg.png"
import canva from "../../assets/canvaimg.png"
import illustrator from "../../assets/illustratorimg.png"
import threeD from "../../assets/3dimg.png"
import figma from "../../assets/figmaimg.png"
import CourseExplorer from '../../MyComponents/CourseExplorer';
import LearningStyle from '../../MyComponents/LearningStyle';
import Testimonials from '../../MyComponents/Testimonials';
import FAQs from '../../MyComponents/FooterPages/newfaq';
const courses = [
  { title: "Adobe XD", image: adobe ,path:"/Adobe-XD"},
  { title: "Corel Draw", image: corel,path:"/Corel-Draw" },
  { title: "Photoshop", image: photoshop,path:"/Photo-Shop" },
  { title: "Canva", image: canva,path:"/Canva" },
  { title: "Illustrator", image: illustrator,path:"/illustrator" },
  { title: "3D Modeling",image: threeD,path:"/3D-model" },
  { title: "Figma", image: figma,path:"/Figma" },
 
];
const GraphicDesignPortal = () =>{
  const designpage = heroContent.designpage;
    return (
       <>
         <GuestNav />
          <Hero2
           titlePart1={designpage.titlePart1}
           titlePart2={designpage.titlePart2}
           description={designpage.description}
           buttonText={designpage.buttonText}
           leftImage={leftimg}
           rightImage={rightimg}
         /> 
        <CourseExplorer
        title="Explore Our Fun & Skill-Boosting Design Courses"
        highlightText="Design Courses"
        courses={courses}
      />
        
        <LearningStyle/>
         <Testimonials/>
         <FAQs/> 
         <Footer /> 
       </>
     );
}
export default GraphicDesignPortal